import * as styles from '../../styles/components/Users.less';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { withTranslation, WithTranslation } from "react-i18next";
import Loader from '../common/Loader';
import { useActions } from '../../hooks/useActions';
import { useAppSelector } from '../../store/hooks';
import { EntityId } from '../../types/models';

interface UsersOwnProps {
  filterCustomers: EntityId[];
  className?: string;
  isLoading?: boolean;
}

const Users = (props: UsersOwnProps & WithTranslation) => {
  const { t } = props; // [t, i18n]
  const actions = useActions();
  const users = useAppSelector((store) => store.users.users);
  const [showDisabledUsers, setShowDisabledUsers] = useState(false);

  useEffect(() => {
    actions.fetchUsers('*'); // customerId or '*'
  }, [actions]);

  // Boolean toggle tickbox handler
  const handleShowDisabledCheckBox = (_event: React.ChangeEvent<HTMLInputElement>) => {
    setShowDisabledUsers((prev) => !prev);
  };

  const renderUsers = () => [...users] // copy: .sort() mutates in place (redux state)
    .sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1))
    .map((user, i) => (
      <div key={i} className={((!user.disabled || showDisabledUsers) && user.customerId !== undefined && props.filterCustomers.indexOf(user.customerId) > -1) ? props.className : 'hidden'}>
        <Link
          style={{float: 'left', color: user.disabled ? 'grey' : 'green'}}
          to={`/user/${user.uid}`}
          key={i}>{user.name}
        </Link> - {user.customerId}
      </div>
    ));

  return (
    <div>
      <h2 className={styles.title}>
        {t('main.users')}
        <Link className="button success" to="/user/0">
          <i className="fa fa-plus-square"></i>
        </Link>
      </h2>
      <label>
        <input
          type="checkbox"
          onChange={handleShowDisabledCheckBox}
        />
        {t('user.showDisabled')}
      </label>
      {props.isLoading && <Loader />}
      {renderUsers()}
    </div>
  );
};

export default withTranslation('common')(Users);
